import * as React from 'react';
import './spinner.css';

const spinner = (props) => {
  return <>
    <div className='spinner'></div>
    <div className="spinner-text">{props.text}</div>
  </>
}

export default spinner;